import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Logo from "../assets/images/rabta logo.png";
import { FaArrowLeft } from "react-icons/fa";

export default function ConsumerLoginCashbacks() {
    const navigate = useNavigate();
    const [cashbacks, setCashbacks] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const stored = localStorage.getItem("consumer");
        if (!stored) {
            navigate("/");
            return;
        }

        const user = JSON.parse(stored);
        setLoading(true);

        // fetch(
        //     `${process.env.REACT_APP_API_URL}consumers/cashgram/history/${user.mobileNumber}`
        // )
        //     .then((res) => res.json())
        //     .then((data) => {
        //         if (data?.status === "success") {
        //             setCashbacks(data?.data || []);
        //         }
        //     })
        //     .catch((error) => {
        //         console.error("Error fetching cashbacks:", error);
        //     })
        //     .finally(() => {
        //         setLoading(false);
        //     });
    }, [navigate]);

    const handleLogout = () => {
        localStorage.removeItem("consumer");
        navigate("/");
    };

    return (
        <div className="main-bg">
            <div className="congrats-page">
                <div className="backBtn-wrapper">
                    <a className="backBtn" onClick={handleLogout}>
                        <FaArrowLeft style={{ marginRight: "6px" }} />
                        <p>Logout</p>
                    </a>
                </div>
                <div>
                    <img src={Logo} alt="logo" className="logo-main" />

                    <div className="entries-table">
                        <h3 style={{ marginBottom: '10px' }}>Cashbak History</h3>

                        {loading ? (
                            <div style={{
                                textAlign: 'center',
                                padding: '40px 20px',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                gap: '15px'
                            }}>
                                <div className="loader" style={{
                                    border: '2px solid #f3f3f3',
                                    borderTop: '2px solid #016400',
                                    borderRadius: '50%',
                                    width: '20px',
                                    height: '20px',
                                    animation: 'spin 1s linear infinite'
                                }}></div>
                                <style>
                                    {`
                                        @keyframes spin {
                                            0% { transform: rotate(0deg); }
                                            100% { transform: rotate(360deg); }
                                        }
                                    `}
                                </style>
                            </div>
                        ) : (
                            <div className="table-content">
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Cashback</th>
                                            <th>Status</th>
                                            <th>Created At</th>
                                            <th>Claimed At</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {cashbacks && cashbacks?.length > 0 ? (
                                            cashbacks?.map((item, i) => (
                                                <tr key={item._id || i}>
                                                    <td>₹{item.cashback}</td>

                                                    <td>
                                                        {item.cashgramStatus === "CASHGRAM_PENDING" && item.cashgramLink ? (
                                                            <a
                                                                className="claim-cashback"
                                                                href={item.cashgramLink}
                                                                target="_blank"
                                                                rel="noreferrer"
                                                            >
                                                                Claim
                                                            </a>
                                                        ) : item.cashgramStatus === "CASHGRAM_REDEEMED" ? (
                                                            <span className="redeemed-text">Claimed</span>
                                                        ) : item.cashgramStatus === "CASHGRAM_EXPIRED" ? (
                                                            <span className="redeemed-text">Expired</span>
                                                        ) : item.cashgramStatus === "CASHGRAM_TRANSFER_REVERSAL" ? (
                                                            <span className="redeemed-text">Reversed</span>
                                                        ) : (
                                                            <span>{"--"}</span>
                                                        )}
                                                    </td>

                                                    <td>
                                                        {item.cashgramLink && item.cashgramCreatedDate
                                                            ? new Date(item.cashgramCreatedDate).toLocaleString()
                                                            : "--"}
                                                    </td>

                                                    <td>
                                                        {item.cashgramStatus === "CASHGRAM_REDEEMED" && item.cashgramClaimedDate
                                                            ? new Date(item.cashgramClaimedDate).toLocaleString()
                                                            : "--"}
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td
                                                    colSpan="5"
                                                    style={{ textAlign: "center", fontWeight: "bold", color: "#666" }}
                                                >
                                                    You don’t have any cashbacks.
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div >
    );
}